var _style, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCourse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-javascript-frameworks",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "svg#freepik_stories-javascript-frameworks:not(.animated) .animable {opacity: 0;}svg#freepik_stories-javascript-frameworks.animated #freepik--Floor--inject-14 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) lightSpeedLeft;animation-delay: 0s;}svg#freepik_stories-javascript-frameworks.animated #freepik--Shadows--inject-14 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideUp;animation-delay: 0s;}svg#freepik_stories-javascript-frameworks.animated #freepik--Device--inject-14 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) zoomOut;animation-delay: 0s;}svg#freepik_stories-javascript-frameworks.animated #freepik--Windows--inject-14 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideLeft;animation-delay: 0s;}svg#freepik_stories-javascript-frameworks.animated #freepik--speech-bubbles--inject-14 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) lightSpeedLeft;animation-delay: 0s;}svg#freepik_stories-javascript-frameworks.animated #freepik--Character--inject-14 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) zoomOut;animation-delay: 0s;}            @keyframes lightSpeedLeft {              from {                transform: translate3d(-50%, 0, 0) skewX(20deg);                opacity: 0;              }              60% {                transform: skewX(-10deg);                opacity: 1;              }              80% {                transform: skewX(2deg);              }              to {                opacity: 1;                transform: translate3d(0, 0, 0);              }            }                    @keyframes slideUp {                0% {                    opacity: 0;                    transform: translateY(30px);                }                100% {                    opacity: 1;                    transform: inherit;                }            }                    @keyframes zoomOut {                0% {                    opacity: 0;                    transform: scale(1.5);                }                100% {                    opacity: 1;                    transform: scale(1);                }            }                    @keyframes slideLeft {                0% {                    opacity: 0;                    transform: translateX(-30px);                }                100% {                    opacity: 1;                    transform: translateX(0);                }            }        .animator-hidden { display: none; }")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-14",
    className: "animable",
    style: {
      transformOrigin: "249.05px 344.05px"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-14",
    cx: 249.05,
    cy: 344.05,
    rx: 236.58,
    ry: 136.59,
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "249.05px 344.05px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-14",
    className: "animable animator-hidden",
    style: {
      transformOrigin: "222.724px 331.404px"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--Shadow--inject-14",
    cx: 384.66,
    cy: 408.13,
    rx: 35.11,
    ry: 20.27,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "384.66px 408.13px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-14",
    d: "M66,385.55,26.72,362.88c-1.39-.8-1.39-2.1,0-2.9L243.14,235a5.57,5.57,0,0,1,5,0l39.27,22.67c1.38.8,1.38,2.1,0,2.9L71,385.55A5.55,5.55,0,0,1,66,385.55Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "157.061px 310.276px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-14",
    className: "animable",
    style: {
      transformOrigin: "205.437px 240.078px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--PC--inject-14",
    className: "animable",
    style: {
      transformOrigin: "168.15px 203.378px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Monitor--inject-14",
    className: "animable",
    style: {
      transformOrigin: "168.15px 203.378px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M202.19,350.05l31.62-18.28c3.26-1.89,4.89-4.35,4.89-6.82s0-4.4,0-4.4L200.67,299a7,7,0,0,1-3.15-5.46v-39l-55.23,31.91v39a7,7,0,0,0,3.15,5.45l33.15,19.14C185.11,353.81,195.68,353.81,202.19,350.05Z",
    style: {
      fill: "rgb(234, 57, 93)",
      transformOrigin: "190.495px 303.704px"
    },
    id: "elx37af1ujyh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elmxqcw3o6rp8"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      transformOrigin: "190.495px 303.704px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M202.19,350.05l31.62-18.28c3.26-1.89,4.89-4.35,4.89-6.82s0-4.4,0-4.4L200.67,299a7,7,0,0,1-3.15-5.46v-39l-55.23,31.91v39a7,7,0,0,0,3.15,5.45l33.15,19.14C185.11,353.81,195.68,353.81,202.19,350.05Z",
    id: "elqrfw2y756yj",
    className: "animable",
    style: {
      transformOrigin: "190.495px 303.704px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M155.55,332.36v4.38l-10.12-5.83a7,7,0,0,1-3.15-5.46v-39l10.53-6.07c.21,2.67.45,5.43.67,8.12l-7.38,4.27v30.46a6.93,6.93,0,0,0,3.14,5.45Z",
    style: {
      fill: "rgb(234, 57, 93)",
      transformOrigin: "148.915px 308.56px"
    },
    id: "els27aeus8omm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elz8rg36wuuf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.55,332.36v4.38l-10.12-5.83a7,7,0,0,1-3.15-5.46v-39l10.53-6.07c.21,2.67.45,5.43.67,8.12l-7.38,4.27v30.46a6.93,6.93,0,0,0,3.14,5.45Z",
    style: {
      opacity: 0.7,
      transformOrigin: "148.915px 308.56px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M146.1,323.26a6.94,6.94,0,0,0,3.15,5.45l29.33,16.94c6.52,3.77,17.09,3.77,23.61,0l31.64-18.28c6.52-3.76,6.52-9.86,0-13.62L204.48,296.8a6.94,6.94,0,0,1-3.15-5.45V260.89L146.1,292.8Z",
    style: {
      fill: "rgb(234, 57, 93)",
      transformOrigin: "192.41px 304.684px"
    },
    id: "elhzkyub7jp6i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elfm0cosqujiq"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.1,323.26a6.94,6.94,0,0,0,3.15,5.45l29.33,16.94c6.52,3.77,17.09,3.77,23.61,0l31.64-18.28c6.52-3.76,6.52-9.86,0-13.62L204.48,296.8a6.94,6.94,0,0,1-3.15-5.45V260.89L146.1,292.8Z",
    style: {
      opacity: 0.3,
      transformOrigin: "192.41px 304.684px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el0kctdd6ldv3o"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M210.89,300.51h0l-6.41-3.7a6.94,6.94,0,0,1-3.15-5.45V260.89L146.1,292.8v30.46a6.94,6.94,0,0,0,3.15,5.45l6.3,3.64Z",
    style: {
      fill: "rgb(234, 57, 93)",
      opacity: 0.7,
      transformOrigin: "178.495px 296.62px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elk3j0dpzbr4l"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M210.89,300.51h0l-6.41-3.7a6.94,6.94,0,0,1-3.15-5.45V260.89L146.1,292.8v30.46a6.94,6.94,0,0,0,3.15,5.45l6.3,3.64Z",
    style: {
      opacity: 0.6,
      transformOrigin: "178.495px 296.62px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M238.71,320.56V325c0,2.47-1.64,4.92-4.89,6.81L202.2,350a23.63,23.63,0,0,1-11.27,2.8v-4.38a23.63,23.63,0,0,0,11.27-2.8l31.62-18.29C237.07,325.5,238.71,323,238.71,320.56Z",
    style: {
      fill: "rgb(234, 57, 93)",
      transformOrigin: "214.82px 336.68px"
    },
    id: "elxjzmtxnqhfk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elbwco6bkwucr"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M238.71,320.56V325c0,2.47-1.64,4.92-4.89,6.81L202.2,350a23.63,23.63,0,0,1-11.27,2.8v-4.38a23.63,23.63,0,0,0,11.27-2.8l31.62-18.29C237.07,325.5,238.71,323,238.71,320.56Z",
    style: {
      opacity: 0.2,
      transformOrigin: "214.82px 336.68px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M57.42,365.32a8.45,8.45,0,0,0,7.63-.14L278.63,241.87a8.72,8.72,0,0,0,3.93-6.82V48.11a8.41,8.41,0,0,0-3.69-6.67,8.4,8.4,0,0,0-7.62.14L57.67,164.89a8.68,8.68,0,0,0-3.93,6.81v187A8.47,8.47,0,0,0,57.42,365.32Z",
    style: {
      fill: "rgb(234, 57, 93)",
      transformOrigin: "168.15px 203.378px"
    },
    id: "elqrjatxn2zg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el9jmrmnqxel"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.42,365.32a8.45,8.45,0,0,0,7.63-.14L278.63,241.87a8.72,8.72,0,0,0,3.93-6.82V48.11a8.41,8.41,0,0,0-3.69-6.67,8.4,8.4,0,0,0-7.62.14L57.67,164.89a8.68,8.68,0,0,0-3.93,6.81v187A8.47,8.47,0,0,0,57.42,365.32Z",
    style: {
      opacity: 0.3,
      transformOrigin: "168.15px 203.378px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M65.05,365.17,278.63,241.86a8.69,8.69,0,0,0,3.94-6.81V48.1c0-2.51-1.77-3.52-3.94-2.27L65.05,169.14A8.72,8.72,0,0,0,61.12,176V362.9C61.12,365.41,62.88,366.43,65.05,365.17Z",
    style: {
      fill: "rgb(234, 57, 93)",
      transformOrigin: "171.845px 205.502px"
    },
    id: "eljakhrge1a7i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.05,365.17,278.63,241.86a8.69,8.69,0,0,0,3.94-6.81V48.1c0-2.51-1.77-3.52-3.94-2.27L65.05,169.14A8.72,8.72,0,0,0,61.12,176V362.9C61.12,365.41,62.88,366.43,65.05,365.17Z",
    style: {
      fill: "rgb(234, 57, 93)",
      transformOrigin: "171.845px 205.502px"
    },
    id: "elq5ynzcs7h3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elstwwy3ss6g"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.05,365.17,278.63,241.86a8.69,8.69,0,0,0,3.94-6.81V48.1c0-2.51-1.77-3.52-3.94-2.27L65.05,169.14A8.72,8.72,0,0,0,61.12,176V362.9C61.12,365.41,62.88,366.43,65.05,365.17Z",
    style: {
      opacity: 0.5,
      transformOrigin: "171.845px 205.502px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M64.47,365.47a8.48,8.48,0,0,1-7-.15,8.43,8.43,0,0,1-3.69-6.68v-21l7.38,4.27v21C61.11,365.2,62.56,366.23,64.47,365.47Z",
    style: {
      fill: "rgb(234, 57, 93)",
      transformOrigin: "59.125px 351.897px"
    },
    id: "elrw0axc9gdpq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ela9az2qs9nup"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.47,365.47a8.48,8.48,0,0,1-7-.15,8.43,8.43,0,0,1-3.69-6.68v-21l7.38,4.27v21C61.11,365.2,62.56,366.23,64.47,365.47Z",
    style: {
      opacity: 0.7,
      transformOrigin: "59.125px 351.897px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M61.12,341.88v21c0,2.51,1.76,3.53,3.93,2.27L278.63,241.86a8.69,8.69,0,0,0,3.94-6.81V214Z",
    style: {
      fill: "rgb(234, 57, 93)",
      transformOrigin: "171.845px 289.845px"
    },
    id: "eljily87kedr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ellfvcjan4ri"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      transformOrigin: "171.845px 289.845px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.12,341.88v21c0,2.51,1.76,3.53,3.93,2.27L278.63,241.86a8.69,8.69,0,0,0,3.94-6.81V214Z",
    id: "elmuzcwwmxc3m",
    className: "animable",
    style: {
      transformOrigin: "171.845px 289.845px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M68.5,326.37v-148a5.19,5.19,0,0,1,2.36-4.09l202-116.61c1.3-.75,2.36-.14,2.36,1.37V207a5.22,5.22,0,0,1-2.36,4.09l-202,116.6C69.55,328.48,68.5,327.87,68.5,326.37Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "171.86px 192.693px"
    },
    id: "elxps1s5fst9p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.84,286.48a8.14,8.14,0,0,0-3.69,6.39c0,2.35,1.65,3.31,3.69,2.13a8.16,8.16,0,0,0,3.69-6.39C175.53,286.25,173.88,285.3,171.84,286.48Z",
    style: {
      fill: "rgb(234, 57, 93)",
      transformOrigin: "171.84px 290.739px"
    },
    id: "eliz17yw54kf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el6mg97fa04j3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171.84,286.48a8.14,8.14,0,0,0-3.69,6.39c0,2.35,1.65,3.31,3.69,2.13a8.16,8.16,0,0,0,3.69-6.39C175.53,286.25,173.88,285.3,171.84,286.48Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "171.84px 290.739px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M62.27,172.06A8.39,8.39,0,0,0,61.11,176V341.88l-7.38-4.27V171.7a8.27,8.27,0,0,1,1.16-3.89Z",
    style: {
      fill: "rgb(234, 57, 93)",
      transformOrigin: "58px 254.845px"
    },
    id: "elethyzbw8va",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elzm92g7iglus"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.27,172.06A8.39,8.39,0,0,0,61.11,176V341.88l-7.38-4.27V171.7a8.27,8.27,0,0,1,1.16-3.89Z",
    style: {
      opacity: 0.7,
      transformOrigin: "58px 254.845px"
    },
    className: "animable"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Keyboard--inject-14",
    className: "animable",
    style: {
      transformOrigin: "247.402px 373.59px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-14",
    d: "M138.9,407.94l53.36,30.9a6.6,6.6,0,0,0,6,0L355.9,348c1.66-1,1.66-2.5,0-3.46l-53.37-30.9a6.6,6.6,0,0,0-6,0L138.9,404.49C137.25,405.44,137.24,407,138.9,407.94Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "247.402px 376.24px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--keyboard--inject-14",
    className: "animable",
    style: {
      transformOrigin: "246.889px 371.393px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M352.67,339a2.11,2.11,0,0,0-1.24-1.73L301.3,308.34a6.6,6.6,0,0,0-6,0l-153,88.46a2.12,2.12,0,0,0-1.23,1.73v5.26a2.08,2.08,0,0,0,1.24,1.72l50.11,28.94a6.63,6.63,0,0,0,6,0l153-88.33a2.1,2.1,0,0,0,1.24-1.72Z",
    style: {
      fill: "rgb(234, 57, 93)",
      transformOrigin: "246.87px 371.393px"
    },
    id: "ele08i901u0j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elyke7nfjngrk"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M352.67,339a2.11,2.11,0,0,0-1.24-1.73L301.3,308.34a6.6,6.6,0,0,0-6,0l-153,88.46a2.12,2.12,0,0,0-1.23,1.73v5.26a2.08,2.08,0,0,0,1.24,1.72l50.11,28.94a6.63,6.63,0,0,0,6,0l153-88.33a2.1,2.1,0,0,0,1.24-1.72Z",
    style: {
      opacity: 0.5,
      transformOrigin: "246.87px 371.393px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M192.45,429.07l-50.11-28.81c-1.65-.95-1.66-2.49,0-3.45l153-88.46a6.6,6.6,0,0,1,6,0l50.13,28.94c1.65,1,1.65,2.5,0,3.46l-153,88.33A6.63,6.63,0,0,1,192.45,429.07Z",
    style: {
      fill: "rgb(234, 57, 93)",
      transformOrigin: "246.903px 368.713px"
    },
    id: "eloqu5t346zrq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elodl0s6a0n7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M192.45,429.07l-50.11-28.81c-1.65-.95-1.66-2.49,0-3.45l153-88.46a6.6,6.6,0,0,1,6,0l50.13,28.94c1.65,1,1.65,2.5,0,3.46l-153,88.33A6.63,6.63,0,0,1,192.45,429.07Z",
    style: {
      opacity: 0.3,
      transformOrigin: "246.903px 368.713px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M195.25,429.78v5.38a6.37,6.37,0,0,1-2.81-.69l-50.09-28.94a2.11,2.11,0,0,1-1.25-1.73v-5.27a2.14,2.14,0,0,0,1.25,1.73l50.09,28.82A6.12,6.12,0,0,0,195.25,429.78Z",
    style: {
      fill: "rgb(234, 57, 93)",
      transformOrigin: "168.175px 416.845px"
    },
    id: "ele09u6pqhxc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elozccht3j5re"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M195.25,429.78v5.38a6.37,6.37,0,0,1-2.81-.69l-50.09-28.94a2.11,2.11,0,0,1-1.25-1.73v-5.27a2.14,2.14,0,0,0,1.25,1.73l50.09,28.82A6.12,6.12,0,0,0,195.25,429.78Z",
    style: {
      opacity: 0.7,
      transformOrigin: "168.175px 416.845px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M259.24,345.6l5.71,3.3a.78.78,0,0,0,.37.09l5.26-2.93-6.14-3.46Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "264.91px 345.795px"
    },
    id: "elqxqmzcuhbb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.11,341.64l5.74,3.31a.71.71,0,0,0,.34.07h.21l5.05-2.92-6.14-3.45Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "271.78px 341.835px"
    },
    id: "elmf9lpuxfy8d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.67,352.29l5.73,3.31a.74.74,0,0,0,.34.07l8.52-4.81-6.14-3.45Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "254.965px 351.54px"
    },
    id: "eltez8bt7lgsn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.8,356.26l5.72,3.3a.78.78,0,0,0,.35.08l5.27-2.93L246,353.26Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "246.47px 356.45px"
    },
    id: "elp4xtz1pldnm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.4,408.18l5.27-2.93-6.14-3.45-5.2,3,5.73,3.32A.94.94,0,0,0,209.4,408.18Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "209px 404.99px"
    },
    id: "elvreqgef1e6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.92,360.22l5.71,3.3a.71.71,0,0,0,.37.09l5.26-2.93-6.14-3.46Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "239.59px 360.415px"
    },
    id: "eldikzhpl4zzs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.21,347.09l-5.2,3,5.72,3.3a.67.67,0,0,0,.35.08l5.27-2.93Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "272.68px 350.28px"
    },
    id: "el8nhxh0ihn5h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253,374l5.27-2.93-6.15-3.45-5.2,3,5.73,3.31A.75.75,0,0,0,253,374Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "252.595px 370.81px"
    },
    id: "el3bwqxlm59eh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280,349.51l5.26-2.93-6.14-3.46-5.2,3,5.74,3.31A.71.71,0,0,0,280,349.51Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "279.59px 346.315px"
    },
    id: "elfgfzfc68jgb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.13,378l5.26-2.93-6.14-3.46-5.2,3,5.71,3.3A.71.71,0,0,0,246.13,378Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "245.72px 374.805px"
    },
    id: "elgl9c1jy6r7w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.26,382l5.26-2.93-6.14-3.46-5.2,3,5.73,3.31A.78.78,0,0,0,239.26,382Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "238.85px 378.805px"
    },
    id: "el6f5pxltagtu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.74,366.1l11.05-6.27-13.9-7.94L258,355.31l7.27,4.19a.36.36,0,0,1,.21.3.32.32,0,0,1-.18.27l-4.59,2.65,5.7,3.29A.73.73,0,0,0,266.74,366.1Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "267.895px 358.995px"
    },
    id: "elriy3f0tqwea",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.18,368.16l5.73,3.31a.71.71,0,0,0,.34.07l5.27-2.93-6.15-3.45Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "225.85px 368.35px"
    },
    id: "el7ek2lsvheo9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.87,370.07l5.27-2.93L259,363.69l-5.2,3,5.69,3.28A.74.74,0,0,0,259.87,370.07Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "259.47px 366.88px"
    },
    id: "elbtve1b9ojak",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.57,406.31l5.27-2.93-6.15-3.46-5.2,3,5.71,3.29A.78.78,0,0,0,181.57,406.31Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "181.165px 403.115px"
    },
    id: "elca89yi8is9e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.2,399.9l5.74,3.32a.84.84,0,0,0,.33.07l.21,0,5.06-2.92-6.15-3.45Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "170.87px 400.105px"
    },
    id: "eldg5jgi0jn0w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.15,409.75h.21l5-2.92-6.14-3.45-5.2,3,5.74,3.31A.86.86,0,0,0,191.15,409.75Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "190.69px 406.566px"
    },
    id: "elb4ikwgy3kim",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.66,416.11l5.27-2.93-6.15-3.45-5.2,3,5.71,3.29A.67.67,0,0,0,195.66,416.11Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "195.255px 412.92px"
    },
    id: "el50q3t71cl9b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.07,395.93l5.73,3.32a.94.94,0,0,0,.34.07l5.27-2.93-6.15-3.45Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "177.74px 396.13px"
    },
    id: "el8srqhvlmuks",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.53,412.15l5.26-2.94-6.14-3.45-5.19,3,5.73,3.31A.74.74,0,0,0,202.53,412.15Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "202.125px 408.955px"
    },
    id: "elq80l0xrrz6f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.69,384l5.72,3.31a.78.78,0,0,0,.35.07l5.27-2.92L197.88,381Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "198.36px 384.19px"
    },
    id: "elb39zzrqtlk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.56,380.06l5.71,3.3a.71.71,0,0,0,.36.09l5.27-2.93-6.14-3.46Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "205.23px 380.255px"
    },
    id: "elbzaccn35uid",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.43,376.09l5.7,3.3a.76.76,0,0,0,.37.09l5.27-2.93-6.14-3.45Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "212.1px 376.29px"
    },
    id: "elgcfs830klyd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.81,388l5.71,3.29a.73.73,0,0,0,.36.1l5.28-2.94L191,385Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "191.485px 388.195px"
    },
    id: "eltjkpnc2xo1b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.31,372.13l5.73,3.31a.82.82,0,0,0,.34.07l5.27-2.93-6.15-3.45Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "218.98px 372.32px"
    },
    id: "elhdi538nkqrp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.94,392l5.73,3.3a.78.78,0,0,0,.35.08l5.26-2.93L184.14,389Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "184.61px 392.19px"
    },
    id: "el18tpg4x17ap",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.05,364.19l5.74,3.32a.84.84,0,0,0,.33.07l5.27-2.93-6.14-3.46Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "232.72px 364.385px"
    },
    id: "elnuzgdg83mln",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.22,363.25l5.71,3.29a.73.73,0,0,0,.37.09h.21l5.05-2.92-6.14-3.45Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "249.89px 363.445px"
    },
    id: "el4m72u2ylkij",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.31,332.87l5.71,3.29a.75.75,0,0,0,.36.09l5.27-2.93-6.15-3.45Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "286.98px 333.06px"
    },
    id: "elhwm4n6j6ita",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.18,328.9l5.71,3.29a.71.71,0,0,0,.36.09l5.27-2.93-6.14-3.45Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "293.85px 329.09px"
    },
    id: "eleqamzokecyj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.35,367.21l5.71,3.3a.75.75,0,0,0,.36.09l5.27-2.93-6.14-3.46Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "243.02px 367.405px"
    },
    id: "el68q7jd3lful",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.05,324.93l5.71,3.3a.77.77,0,0,0,.36.09l5.27-2.94-6.14-3.45Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "300.72px 325.125px"
    },
    id: "elaxrt71grnqa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.17,362.66h.21l5.05-2.92-6.14-3.45-5.2,3,5.71,3.29A.76.76,0,0,0,257.17,362.66Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "256.76px 359.475px"
    },
    id: "el0q5tipn5fg2d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.07,337.35l5.7,3.29a.82.82,0,0,0,.38.1l5.26-2.93-6.14-3.46Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "294.74px 337.545px"
    },
    id: "elgpotjzj8ia5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.82,329.41l5.7,3.29a.73.73,0,0,0,.37.1l5.27-2.93L308,326.42Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "308.49px 329.61px"
    },
    id: "elbvj2rhgx4b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,336.77l5.27-2.93-6.15-3.46-5.2,3,5.73,3.31A.78.78,0,0,0,302,336.77Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "301.595px 333.575px"
    },
    id: "eli76ntwdenf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.21,333.25a.83.83,0,0,0,.32.07l.22,0,5.05-2.91-13.91-7.94-5.2,3Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "319.245px 327.895px"
    },
    id: "elcnrnbjssv1e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.47,371.18l5.72,3.3a.7.7,0,0,0,.36.09l.21,0,5.06-2.91-6.15-3.46Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "236.145px 371.385px"
    },
    id: "elyo4yoa1vx3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.79,341.25H310l5.05-2.92-6.14-3.45-5.2,3,5.71,3.29A.76.76,0,0,0,309.79,341.25Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "309.38px 338.065px"
    },
    id: "el47h5k0pw3j6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.66,337.28l5.27-2.93-6.15-3.45-5.2,3,5.7,3.29A.79.79,0,0,0,316.66,337.28Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "316.255px 334.09px"
    },
    id: "el1n5b16uujp2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.11,391l5.71,3.29a.76.76,0,0,0,.37.1l5.26-2.93L201.31,388Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "201.78px 391.195px"
    },
    id: "eleie2hctc0i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.37,399l5.7,3.29a.73.73,0,0,0,.37.09h.21l5.06-2.92L187.56,396Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "188.04px 399.19px"
    },
    id: "el7ryfox289r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.89,401.82l5.27-2.93L204,395.43l-5.19,3,5.74,3.31A.68.68,0,0,0,204.89,401.82Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "204.485px 398.625px"
    },
    id: "elwg977qr3y8o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198,405.78l5.27-2.93-6.15-3.45-5.2,3,5.74,3.31A.71.71,0,0,0,198,405.78Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "197.595px 402.59px"
    },
    id: "elgeddw4cbznj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.76,397.85l.22,0,5.05-2.91-6.14-3.46-5.2,3,5.7,3.29A.73.73,0,0,0,211.76,397.85Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "211.36px 394.665px"
    },
    id: "elo4q6osfdaxr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.6,375.15l5.72,3.3a.77.77,0,0,0,.36.08h.21l5.05-2.92-6.14-3.45Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "229.27px 375.345px"
    },
    id: "elqojbbjiv4v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.51,389.91l5.27-2.93-6.15-3.45-5.2,3,5.71,3.29A.78.78,0,0,0,225.51,389.91Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "225.105px 386.72px"
    },
    id: "el5z9qiijfzgu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.64,393.88,223.9,391l-6.14-3.45-5.2,3,5.74,3.32A.89.89,0,0,0,218.64,393.88Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "218.23px 390.721px"
    },
    id: "elz2zi88v4x9c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.86,383.09l5.7,3.29a.73.73,0,0,0,.37.09l5.27-2.93-6.14-3.45Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "215.53px 383.28px"
    },
    id: "elxk6toy1s1e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.24,395l5.7,3.29a.77.77,0,0,0,.38.09l5.26-2.93L194.44,392Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "194.91px 395.19px"
    },
    id: "elhs2jhpjwjtt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.73,379.12l5.71,3.29a.73.73,0,0,0,.37.09l5.26-2.93-6.14-3.45Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "222.4px 379.31px"
    },
    id: "elk6aqvj94bgp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203,387.05l5.7,3.3a.73.73,0,0,0,.37.09l.21,0,5.06-2.91-6.15-3.46Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "208.67px 387.255px"
    },
    id: "elatce2aqj8dn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.38,385.94l5.27-2.93-6.15-3.45-5.19,3,5.72,3.3A.67.67,0,0,0,232.38,385.94Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "231.98px 382.75px"
    },
    id: "elg8axty1hqhj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273,337.67l5.73,3.31a.77.77,0,0,0,.34.07l5.27-2.93-6.15-3.45Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "278.67px 337.86px"
    },
    id: "el0kxk8s3nzfh9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.52,400.87l-5.2,3,5.74,3.31a.71.71,0,0,0,.34.07h.21l5.06-2.92Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "163.995px 404.06px"
    },
    id: "eldwxx23nk5k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.82,403.89l-7.73,4.46,5.74,3.32a.84.84,0,0,0,.33.07h.22l7.58-4.38Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "173.025px 407.815px"
    },
    id: "eleaixhznsvhf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.18,394.8l-6.29,3.63,5.72,3.29a.7.7,0,0,0,.36.09l6.35-3.55Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "155.105px 398.305px"
    },
    id: "elfxr45vz92kl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.91,413.7l-6.28,3.63,5.7,3.29a.78.78,0,0,0,.37.09l6.35-3.56Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "187.84px 417.205px"
    },
    id: "el7m35gviq0w9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.39,407.34l-9.53,5.5,5.73,3.31a.77.77,0,0,0,.34.07h.21l9.4-5.42Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "181.7px 411.78px"
    },
    id: "el03lybz4o3naf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.92,395.49l5.26-2.93L165,389.11l-5.2,3,5.71,3.3A.73.73,0,0,0,165.92,395.49Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "165.49px 392.302px"
    },
    id: "ellt65ubzhab",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.39,421.81l5.71,3.3a.83.83,0,0,0,.36.08l7.8-4.39-6.14-3.45Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "196.325px 421.27px"
    },
    id: "elulpn20a244",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.79,391.52l5.27-2.93-6.15-3.45-5.19,3,5.73,3.31A.77.77,0,0,0,172.79,391.52Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "172.39px 388.33px"
    },
    id: "el294amzz4f7k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.27,373.93l.21,0,5.06-2.92-6.15-3.45-5.19,3,5.71,3.3A.71.71,0,0,0,203.27,373.93Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "202.87px 370.746px"
    },
    id: "eldchdgbkwkr5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.14,370l5.27-2.93-6.14-3.46-5.2,3,5.72,3.3A.69.69,0,0,0,210.14,370Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "209.74px 366.805px"
    },
    id: "elamyqe7hxn7u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.4,377.89h.21l5-2.92-6.14-3.45-5.2,3L196,377.8A.76.76,0,0,0,196.4,377.89Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "195.94px 374.706px"
    },
    id: "elwvw9by3hbm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.53,383.59l.22,0,5.05-2.91-6.14-3.46-5.2,3,5.72,3.3A.65.65,0,0,0,186.53,383.59Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "186.13px 380.406px"
    },
    id: "elgvbaw7rs345",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.66,387.56l5.27-2.93-6.14-3.46-5.2,3,5.73,3.31A.71.71,0,0,0,179.66,387.56Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "179.26px 384.365px"
    },
    id: "elyklexzf346f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.13,342.87l5.74,3.32a.84.84,0,0,0,.33.06h.21l5-2.92-6.14-3.45Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "331.77px 343.065px"
    },
    id: "elulngl500cer",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.31,363.54l5.7,3.29a.68.68,0,0,0,.37.1l5.27-2.93-6.14-3.46Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "295.98px 363.735px"
    },
    id: "eld2wr8b6jny8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.38,350.81l5.71,3.29a.75.75,0,0,0,.36.09h.21l11.93-6.89-6.14-3.45Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "321.485px 349.02px"
    },
    id: "elo2469he1rg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.18,359.58l5.7,3.28a.71.71,0,0,0,.38.1l5.27-2.93-6.15-3.45Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "302.855px 359.77px"
    },
    id: "el13inycpkwyt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.06,355.61l5.68,3.27a.65.65,0,0,0,.39.11l5.27-2.93-6.15-3.45Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "309.73px 355.8px"
    },
    id: "elm0vvf5ah9eo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217,366h.22l5.05-2.92-6.14-3.46-5.2,3,5.7,3.29A.76.76,0,0,0,217,366Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "216.6px 362.81px"
    },
    id: "el7pyundumde2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.43,331.41l-5.2,3,13.51,7.8a.84.84,0,0,0,.33.07l.21,0,5.05-2.92Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "334.78px 336.845px"
    },
    id: "elal4thn9d0s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.76,411.79l5.7,3.29a.78.78,0,0,0,.37.09l6.35-3.56L213,408.16Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "212.97px 411.665px"
    },
    id: "elb0vys6jot9m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.71,407.19l5.7,3.29a.77.77,0,0,0,.38.1l.21,0L260.06,388l-6.15-3.46Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "237.385px 397.56px"
    },
    id: "elsdkkf45je37",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.27,404.21l5.27-2.93-6.14-3.45-5.2,3,5.73,3.3A.77.77,0,0,0,216.27,404.21Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "215.87px 401.02px"
    },
    id: "elrmm6if3naqf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.8,416.38l5.7,3.29a.79.79,0,0,0,.37.1l6.35-3.56-6.14-3.46Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "205.01px 416.26px"
    },
    id: "elp4fn6qbg077",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.59,383.59l5.71,3.3a.82.82,0,0,0,.36.09l.22,0,6.13-3.54L261.87,380Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "261.8px 383.49px"
    },
    id: "eli9zfx0vziyk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.5,374.4l5.73,3.31a.73.73,0,0,0,.35.08l.21,0,6.14-3.54-6.14-3.46Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "277.715px 374.29px"
    },
    id: "el60x5q9fj4fe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.54,379l5.74,3.31a.77.77,0,0,0,.34.07l6.35-3.56-6.14-3.45Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "269.755px 378.875px"
    },
    id: "elpwdnasn159b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.46,369.81l5.71,3.29a.73.73,0,0,0,.37.09h.21l7.58-4.38-6.14-3.45Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "286.395px 369.275px"
    },
    id: "elk0dmtjbt5f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.83,345.54l.21,0,5.06-2.91L286,339.15l-5.2,3,5.73,3.31A.75.75,0,0,0,286.83,345.54Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "286.45px 342.345px"
    },
    id: "elf8bh5w1lux8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.49,358.48l.21,0,5.06-2.92-6.14-3.45-5.2,3,5.72,3.31A.75.75,0,0,0,295.49,358.48Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "295.09px 355.296px"
    },
    id: "elth5jyjr6fl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.26,372.47l14.31-8.16-6.15-3.45-14.24,8.22,5.74,3.31A.69.69,0,0,0,271.26,372.47Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "275.375px 366.665px"
    },
    id: "elsuiyj5nkjaa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.68,349.7h.22l5.05-2.92-6.14-3.45-5.2,3,5.73,3.31A.77.77,0,0,0,310.68,349.7Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "310.28px 346.516px"
    },
    id: "el489l69njqg4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.56,345.74l.21,0,5.05-2.91-6.14-3.46-5.2,3,5.72,3.31A.79.79,0,0,0,317.56,345.74Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "317.15px 342.556px"
    },
    id: "eltm7spxmnp2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.38,376.44l5.27-2.93-6.14-3.46-5.2,3,5.71,3.3A.8.8,0,0,0,264.38,376.44Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "263.98px 373.245px"
    },
    id: "elypy54pe7alg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.92,345.22h.21l5.05-2.92L302,338.84l-5.2,3,5.7,3.28A.68.68,0,0,0,302.92,345.22Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "302.49px 342.031px"
    },
    id: "el2jq4py5jy4e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230,396.27l5.27-2.93-6.15-3.45-5.19,3,5.73,3.31A.71.71,0,0,0,230,396.27Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "229.6px 393.08px"
    },
    id: "elz3hihw76b2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.51,380.4l5.27-2.93L256.63,374l-5.19,3,5.74,3.32A.91.91,0,0,0,257.51,380.4Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "257.11px 377.2px"
    },
    id: "el1r5zpokz647",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.15,400.24h.21l5-2.92-6.14-3.45-5.2,3,5.74,3.31A.71.71,0,0,0,223.15,400.24Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "222.69px 397.058px"
    },
    id: "el5o697wx5pe9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.89,392.31l5.27-2.93L236,385.92l-5.2,3,5.75,3.32A.72.72,0,0,0,236.89,392.31Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "236.48px 389.115px"
    },
    id: "elhvgz1v52l6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.77,388.34H244l5.05-2.92L242.89,382l-5.2,3,5.71,3.3A.71.71,0,0,0,243.77,388.34Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "243.37px 385.174px"
    },
    id: "ellc9n5dlmebc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.64,384.37h.21l5.06-2.92L249.76,378l-5.2,3,5.74,3.31A.86.86,0,0,0,250.64,384.37Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "250.235px 381.185px"
    },
    id: "el9w9q3u289e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.75,356.33,239,353.4l-6.15-3.46-5.2,3,5.71,3.29A.66.66,0,0,0,233.75,356.33Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "233.325px 353.136px"
    },
    id: "eldalh38j0kjt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.43,341.77l.21,0,5.06-2.91-6.15-3.46-5.2,3,5.74,3.32A.86.86,0,0,0,324.43,341.77Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "324.025px 338.586px"
    },
    id: "elm4amgz5gzl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.5,348.39l5.26-2.93L246.62,342l-5.2,3,5.7,3.29A.77.77,0,0,0,247.5,348.39Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "247.09px 345.195px"
    },
    id: "elu5fjf8goz1a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.76,339.58l5.27-2.93-6.15-3.46-5.19,3,5.71,3.3A.7.7,0,0,0,262.76,339.58Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "262.36px 336.385px"
    },
    id: "elztk3xcg6qcj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.89,343.55l5.26-2.93L255,337.16l-5.2,3,5.71,3.3A.76.76,0,0,0,255.89,343.55Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "255.475px 340.355px"
    },
    id: "el4vggog5a3sp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.88,360.3l5.27-2.94L226,353.91l-5.19,3,5.71,3.3A.82.82,0,0,0,226.88,360.3Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "226.48px 357.105px"
    },
    id: "elyalga4gl6p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.62,352.36h.22l5-2.92L239.75,346l-5.2,3,5.7,3.29A.76.76,0,0,0,240.62,352.36Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "240.195px 349.181px"
    },
    id: "elxrreje6kfg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.63,335.61l5.27-2.93-6.14-3.45-5.2,3,5.71,3.29A.7.7,0,0,0,269.63,335.61Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "269.23px 332.42px"
    },
    id: "elfz9n6aght3c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.58,317.75l5.26-2.93L298.5,313l-5.2,3,2.92,1.65A.83.83,0,0,0,296.58,317.75Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "297.57px 315.375px"
    },
    id: "el0q4ti5jwic3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308,324.35l5.27-2.93L307.12,318l-5.2,3,5.71,3.3A.78.78,0,0,0,308,324.35Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "307.595px 321.177px"
    },
    id: "el85q4t4chac3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276,329.66l.21,0,5.05-2.92-3.34-1.8-5.2,3,2.91,1.65A.89.89,0,0,0,276,329.66Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "276.99px 327.3px"
    },
    id: "el4td4u26vktu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.83,325.69l.21,0,5-2.91L284.76,321l-5.2,3,2.93,1.65A.77.77,0,0,0,282.83,325.69Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "283.8px 323.347px"
    },
    id: "elonk7ptfhxyd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.7,321.72l5.27-2.93L291.63,317l-5.2,3,2.94,1.66A.84.84,0,0,0,289.7,321.72Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "290.7px 319.36px"
    },
    id: "el94pvnp3yamn",
    className: "animable"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Windows--inject-14",
    className: "animable",
    style: {
      transformOrigin: "224.725px 195.467px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "el8r621yjv32q"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8,
      transformOrigin: "194.39px 196.58px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M297.52,62.76V211.21a6.81,6.81,0,0,1-3.08,5.34L94.35,332.29a2,2,0,0,1-1,.3,1.74,1.74,0,0,1-.39,0,1.14,1.14,0,0,1-.26-.09l-.17-.1-.18-.12a1.22,1.22,0,0,1-.17-.15,2.52,2.52,0,0,1-.57-.81,3.88,3.88,0,0,1-.32-1.56V182a6.85,6.85,0,0,1,3.09-5.35L294.44,61a2.25,2.25,0,0,1,2.07-.26,1.82,1.82,0,0,1,.27.15l0,0a.8.8,0,0,1,.2.21.48.48,0,0,1,.09.11.54.54,0,0,1,.1.16,1.38,1.38,0,0,1,.18.39,1.15,1.15,0,0,1,.07.28.07.07,0,0,1,0,.06,1.26,1.26,0,0,1,.05.28C297.51,62.49,297.52,62.62,297.52,62.76Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "194.405px 196.599px"
    },
    id: "elvk5ua8x8zxb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.81,61.56a.8.8,0,0,1,.3.06l0,0h0l.06,0,.08.11h0l.08.11s0,0,0,.05v0l.09.29v0l0,0v0a.56.56,0,0,0,0,.07c0,.1,0,.2,0,.31V211.21a5.81,5.81,0,0,1-2.58,4.48L93.85,331.43a1,1,0,0,1-.52.16h0l-.21,0-.07,0-.13-.09h0v0l0-.05a1.31,1.31,0,0,1-.33-.47,2.8,2.8,0,0,1-.24-1.16V182a5.79,5.79,0,0,1,2.59-4.48L294.93,61.84a1.94,1.94,0,0,1,.88-.28m0-1a2.78,2.78,0,0,0-1.37.41L94.35,176.66A6.85,6.85,0,0,0,91.26,182v147.7a3.88,3.88,0,0,0,.32,1.56,2.52,2.52,0,0,0,.57.81,1.22,1.22,0,0,0,.17.15l.18.12.17.1a1.14,1.14,0,0,0,.26.09,1.74,1.74,0,0,0,.39,0h.05a2,2,0,0,0,1-.3L294.44,216.55a6.81,6.81,0,0,0,3.08-5.34V62.76c0-.14,0-.27,0-.39a1.26,1.26,0,0,0-.05-.28.07.07,0,0,0,0-.06,1.15,1.15,0,0,0-.07-.28,1.38,1.38,0,0,0-.18-.39.54.54,0,0,0-.1-.16.48.48,0,0,0-.09-.11.8.8,0,0,0-.2-.21l0,0a1.82,1.82,0,0,0-.27-.15,1.63,1.63,0,0,0-.7-.15Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "194.39px 196.55px"
    },
    id: "el488e2ne91of",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el21koxn9s9px"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7,
      transformOrigin: "194.405px 196.599px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M297.52,62.76V211.21a6.81,6.81,0,0,1-3.08,5.34L94.35,332.29a2,2,0,0,1-1,.3,1.74,1.74,0,0,1-.39,0,1.14,1.14,0,0,1-.26-.09l-.17-.1-.18-.12a1.22,1.22,0,0,1-.17-.15,2.52,2.52,0,0,1-.57-.81,3.88,3.88,0,0,1-.32-1.56V182a6.85,6.85,0,0,1,3.09-5.35L294.44,61a2.25,2.25,0,0,1,2.07-.26,1.82,1.82,0,0,1,.27.15l0,0a.8.8,0,0,1,.2.21.48.48,0,0,1,.09.11.54.54,0,0,1,.1.16,1.38,1.38,0,0,1,.18.39,1.15,1.15,0,0,1,.07.28.07.07,0,0,1,0,.06,1.26,1.26,0,0,1,.05.28C297.51,62.49,297.52,62.62,297.52,62.76Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "194.405px 196.599px"
    },
    id: "elm08ijly6fd",
    className: "animable"
  }))))), /*#__PURE__*/React.createElement("path", {
    d: "M296.51,60.71a2.25,2.25,0,0,0-2.07.26L94.35,176.66A6.85,6.85,0,0,0,91.26,182v10.08l-3.94-2.31v-10a6.81,6.81,0,0,1,3.08-5.33L290.5,58.75a2.13,2.13,0,0,1,2.24-.18C293.29,58.9,295.85,60.37,296.51,60.71Z",
    style: {
      fill: "rgb(234, 57, 93)",
      transformOrigin: "191.915px 125.207px"
    },
    id: "elj58u3zcb7ds",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.52,62.73c0-1.94-1.39-2.73-3.08-1.75L94.34,176.67A6.81,6.81,0,0,0,91.26,182v10.08L297.52,72.85Z",
    style: {
      fill: "rgb(234, 57, 93)",
      transformOrigin: "194.39px 126.319px"
    },
    id: "elq5jvtuyl26",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elo48g1kpgjdi"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4,
      transformOrigin: "192.38px 118.666px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M294.44,61,94.35,176.67A6.2,6.2,0,0,0,92.18,179l-3.92-2.26a6.22,6.22,0,0,1,2.14-2.26L290.5,58.75a2.16,2.16,0,0,1,2.24-.19c.55.34,3.11,1.8,3.76,2.15A2.18,2.18,0,0,0,294.44,61Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "192.38px 118.666px"
    },
    id: "eledvxatlwxp7",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "elkmjp9yy0eb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.32,189.79v-10a6.34,6.34,0,0,1,.94-3.08l3.93,2.25a6.18,6.18,0,0,0-.93,3.07v10.08Z",
    style: {
      opacity: 0.15,
      transformOrigin: "89.755px 184.41px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M279,74.21a4.61,4.61,0,0,0-1.74,3.69c0,1.48.78,2.23,1.74,1.68a4.61,4.61,0,0,0,1.74-3.69C280.69,74.41,279.91,73.66,279,74.21Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "279px 76.895px"
    },
    id: "ela6gptgyl9cb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.22,70.59a4.58,4.58,0,0,0-1.74,3.68c0,1.48.78,2.23,1.74,1.68A4.61,4.61,0,0,0,287,72.26C287,70.78,286.18,70,285.22,70.59Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "285.24px 73.2612px"
    },
    id: "elzy0ycee09u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.49,67a4.58,4.58,0,0,0-1.74,3.69c0,1.48.78,2.23,1.74,1.67a4.58,4.58,0,0,0,1.74-3.69C293.23,67.15,292.45,66.4,291.49,67Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "291.49px 69.6694px"
    },
    id: "el6rfj4xbmcsh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elock9kny24o"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.39,332.3l-.38-.22c-.28-.17-.61-.35-1-.53v0l-.52-.29,0,0-.81-.46c-.26-.16-.49-.29-.68-.39s-.32-.18-.38-.21a1.65,1.65,0,0,1-.53-.43,2.31,2.31,0,0,1-.41-.62,3.75,3.75,0,0,1-.36-1.63V189.78l3.94,2.31V329.71a4.63,4.63,0,0,0,.32,1.56,2.52,2.52,0,0,0,.57.81.5.5,0,0,0,.17.15Z",
    style: {
      fill: "rgb(55, 71, 79)",
      opacity: 0.9,
      transformOrigin: "89.855px 261.04px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M158.15,243.47s-7.28-4.71-8.22-4.74l-20.7-.65,8.23,4.38v.36Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "143.69px 240.775px"
    },
    id: "elwv3x9wh3c7j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.67,257.66v-13l35.48-44.11v17.2l-20.69,24.67v.36l20.69.65v17.2Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "140.41px 230.59px"
    },
    id: "el9xitswtse1n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "158.15 200.59 149.93 195.85 114.44 239.96 122.67 244.7 158.15 200.59",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "136.295px 220.275px"
    },
    id: "elo5gq4hkp22",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "114.44 239.96 114.44 252.92 122.67 257.66 122.67 244.7 114.44 239.96",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "118.555px 248.81px"
    },
    id: "eltth1kkcv0wi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.63,252.15l-11,6.36,27.46-100.65,10.62-6.13Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "187.67px 205.12px"
    },
    id: "el5qgr2bp53a3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "206.7 151.73 198.47 146.99 187.85 153.12 196.07 157.86 206.7 151.73",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "197.275px 152.425px"
    },
    id: "elz9rz2ntd7sp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "187.85 153.12 196.07 157.86 168.62 258.51 160.39 253.77 187.85 153.12",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "178.23px 205.815px"
    },
    id: "elngoulka6coj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "208.94 204.66 217.16 209.4 237.85 184.5 229.63 179.76 208.94 204.66",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "223.395px 194.58px"
    },
    id: "eljjrr38jqln",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.85,184.5l-20.69-.78v-17.2l35.48,3.14v13l-35.48,44V209.4l20.69-24.54Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "234.9px 196.59px"
    },
    id: "elu9ndkfd7o5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "208.94 161.78 217.16 166.52 252.65 169.66 244.42 164.92 208.94 161.78",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "230.795px 165.72px"
    },
    id: "elr5qqbeikop",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "217.16 166.52 217.16 183.72 208.94 178.98 208.94 161.78",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "213.05px 172.75px"
    },
    id: "el9jc1btvze7g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "208.94 204.66 217.16 209.4 217.16 226.6 208.94 221.86 208.94 204.66",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "213.05px 215.63px"
    },
    id: "elt6978yovpns",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elky2wvp4id9a"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8,
      transformOrigin: "316.41px 188.91px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M362.13,88.36V236.81a6.82,6.82,0,0,1-3.09,5.35l-85.29,49.2a1.89,1.89,0,0,1-1,.3,1.74,1.74,0,0,1-.39-.05l-.27-.09-.16-.1-.18-.12a1.22,1.22,0,0,1-.17-.15,2.37,2.37,0,0,1-.57-.81,3.88,3.88,0,0,1-.32-1.56V141.08a6.84,6.84,0,0,1,3.08-5.35L359,86.58a2.25,2.25,0,0,1,2.08-.27,1.4,1.4,0,0,1,.26.16l0,0a1,1,0,0,1,.2.2.48.48,0,0,1,.09.11.54.54,0,0,1,.1.16,1.34,1.34,0,0,1,.19.4,1.07,1.07,0,0,1,.07.27.07.07,0,0,1,0,.06,1.26,1.26,0,0,1,.05.28C362.12,88.1,362.13,88.23,362.13,88.36Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "316.41px 188.915px"
    },
    id: "elljun8htfidf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.41,87.16a.63.63,0,0,1,.3.07h0l.06,0,.09.11h0l.07.12,0,0,0,0,.1.29v0l0,0v0a.17.17,0,0,1,0,.07,2.66,2.66,0,0,1,0,.3V236.81a5.82,5.82,0,0,1-2.59,4.48L273.26,290.5a1,1,0,0,1-.52.16h0l-.21,0-.07,0-.13-.08,0,0,0,0,0,0a1.43,1.43,0,0,1-.32-.47,2.8,2.8,0,0,1-.24-1.16V141.08a5.81,5.81,0,0,1,2.58-4.48l85.29-49.15a1.82,1.82,0,0,1,.87-.29m0-1a2.83,2.83,0,0,0-1.37.42l-85.29,49.15a6.84,6.84,0,0,0-3.08,5.35v147.7a3.88,3.88,0,0,0,.32,1.56,2.37,2.37,0,0,0,.57.81,1.22,1.22,0,0,0,.17.15l.18.12.16.1.27.09a1.74,1.74,0,0,0,.39.05h0a1.91,1.91,0,0,0,1-.3L359,242.16a6.84,6.84,0,0,0,3.09-5.35V88.36c0-.13,0-.26,0-.39a1.26,1.26,0,0,0-.05-.28.07.07,0,0,0,0-.06,1.07,1.07,0,0,0-.07-.27,1.34,1.34,0,0,0-.19-.4.54.54,0,0,0-.1-.16.48.48,0,0,0-.09-.11,1,1,0,0,0-.2-.2l0,0a1.4,1.4,0,0,0-.26-.16,1.67,1.67,0,0,0-.71-.15Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "316.43px 188.91px"
    },
    id: "elhhh17h90sj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elt5ehdgzxf7"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8,
      transformOrigin: "316.41px 188.915px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M362.13,88.36V236.81a6.82,6.82,0,0,1-3.09,5.35l-85.29,49.2a1.89,1.89,0,0,1-1,.3,1.74,1.74,0,0,1-.39-.05l-.27-.09-.16-.1-.18-.12a1.22,1.22,0,0,1-.17-.15,2.37,2.37,0,0,1-.57-.81,3.88,3.88,0,0,1-.32-1.56V141.08a6.84,6.84,0,0,1,3.08-5.35L359,86.58a2.25,2.25,0,0,1,2.08-.27,1.4,1.4,0,0,1,.26.16l0,0a1,1,0,0,1,.2.2.48.48,0,0,1,.09.11.54.54,0,0,1,.1.16,1.34,1.34,0,0,1,.19.4,1.07,1.07,0,0,1,.07.27.07.07,0,0,1,0,.06,1.26,1.26,0,0,1,.05.28C362.12,88.1,362.13,88.23,362.13,88.36Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "316.41px 188.915px"
    },
    id: "elc5s6wdd8hkh",
    className: "animable"
  }))))), /*#__PURE__*/React.createElement("path", {
    d: "M361.12,86.31a2.25,2.25,0,0,0-2.08.27l-85.29,49.15a6.84,6.84,0,0,0-3.08,5.35v10.08l-3.94-2.31v-10a6.81,6.81,0,0,1,3.08-5.33l85.3-49.16a2.16,2.16,0,0,1,2.23-.18C357.9,84.5,360.46,86,361.12,86.31Z",
    style: {
      fill: "rgb(234, 57, 93)",
      transformOrigin: "313.925px 117.556px"
    },
    id: "elqek0vric198",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.12,88.34c0-2-1.38-2.74-3.08-1.76l-85.29,49.16a6.81,6.81,0,0,0-3.08,5.34v10.08l91.45-52.7Z",
    style: {
      fill: "rgb(234, 57, 93)",
      transformOrigin: "316.395px 118.655px"
    },
    id: "el5d8lmdwagob",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elr1413jvqxaq"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4,
      transformOrigin: "314.365px 110.98px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M359,86.58l-85.28,49.16a6.3,6.3,0,0,0-2.18,2.28l-3.91-2.26a6.11,6.11,0,0,1,2.14-2.25L355.1,84.35a2.17,2.17,0,0,1,2.24-.18c.56.34,3.11,1.79,3.76,2.14A2.21,2.21,0,0,0,359,86.58Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "314.365px 110.98px"
    },
    id: "elm6mwlubkcr",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "eltiwogisl7rn"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M266.73,148.86v-10a6.37,6.37,0,0,1,.94-3.08l3.92,2.25a6.27,6.27,0,0,0-.92,3.07v10.08Z",
    style: {
      opacity: 0.15,
      transformOrigin: "269.16px 143.48px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M343.55,99.82a4.58,4.58,0,0,0-1.74,3.68c0,1.48.78,2.23,1.74,1.68a4.61,4.61,0,0,0,1.74-3.69C345.29,100,344.51,99.26,343.55,99.82Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "343.55px 102.497px"
    },
    id: "elrm8gt3kani",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.82,96.19a4.6,4.6,0,0,0-1.74,3.69c0,1.48.78,2.23,1.74,1.67a4.55,4.55,0,0,0,1.74-3.69C351.56,96.38,350.79,95.63,349.82,96.19Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "349.82px 98.87px"
    },
    id: "el65ieu6dqpdl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.09,92.56a4.61,4.61,0,0,0-1.74,3.69c0,1.48.78,2.23,1.74,1.67a4.56,4.56,0,0,0,1.75-3.68C357.84,92.76,357.06,92,356.09,92.56Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "356.095px 95.2406px"
    },
    id: "ellsrc72c5pd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elqm0h5z9ckqc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M271.8,291.37l-.38-.22-.95-.53h0l-.52-.3,0,0-.81-.46c-.26-.16-.5-.29-.68-.39s-.32-.18-.38-.21a1.65,1.65,0,0,1-.53-.43,2.31,2.31,0,0,1-.41-.62,3.75,3.75,0,0,1-.36-1.63V148.85l3.94,2.31V288.78a4.63,4.63,0,0,0,.32,1.56,2.37,2.37,0,0,0,.57.81.5.5,0,0,0,.17.15A.23.23,0,0,0,271.8,291.37Z",
    style: {
      fill: "rgb(55, 71, 79)",
      opacity: 0.9,
      transformOrigin: "269.29px 220.11px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M278.24,159.53a1.3,1.3,0,0,1,.16-.57l2.22-4.59a.29.29,0,0,1,.1-.13l0-.05a.15.15,0,0,1,.18,0,.28.28,0,0,1,.07.22V156a2.09,2.09,0,0,1,0,.48,2.89,2.89,0,0,1-.16.42l-1.17,2.42,1.17,1.08a.69.69,0,0,1,.16.23,1.51,1.51,0,0,1,0,.43v1.54a.7.7,0,0,1-.07.31.48.48,0,0,1-.18.21l0,0a.12.12,0,0,1-.1,0l-2.22-2a.47.47,0,0,1-.16-.39Z",
    style: {
      fill: "rgb(234, 57, 93)",
      transformOrigin: "279.612px 158.645px"
    },
    id: "el9iri3uvspv8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.35,148a2.07,2.07,0,0,1,.17-.45.75.75,0,0,1,.33-.35l.83-.48a.12.12,0,0,1,.17,0,.28.28,0,0,1,.08.22.55.55,0,0,1,0,.17l-3.8,16.2a1.82,1.82,0,0,1-.16.44.79.79,0,0,1-.33.37l-.8.46a.13.13,0,0,1-.17,0,.32.32,0,0,1-.08-.23,1.28,1.28,0,0,1,0-.17Z",
    style: {
      fill: "rgb(234, 57, 93)",
      transformOrigin: "285.262px 155.648px"
    },
    id: "elxxh32r2z81",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.23,152.6a1.25,1.25,0,0,1-.15.57l-2.22,4.59a.64.64,0,0,1-.1.14l-.06,0a.14.14,0,0,1-.17,0,.32.32,0,0,1-.07-.23v-1.54a2.09,2.09,0,0,1,0-.48,2.06,2.06,0,0,1,.16-.42l1.17-2.42-1.17-1.07a.67.67,0,0,1-.16-.24,1.51,1.51,0,0,1,0-.43v-1.54a.73.73,0,0,1,.07-.31.54.54,0,0,1,.17-.21l.06,0s.06,0,.1,0l2.22,2a.48.48,0,0,1,.15.4Z",
    style: {
      fill: "rgb(234, 57, 93)",
      transformOrigin: "290.839px 153.469px"
    },
    id: "ell9wz6v58abr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.39,151.53a.18.18,0,0,1,.22,0,.38.38,0,0,1,.09.28v1.69a.85.85,0,0,1-.09.38.56.56,0,0,1-.22.27l-1,.6a.15.15,0,0,1-.21,0,.34.34,0,0,1-.09-.27v-1.7a.88.88,0,0,1,.09-.38.57.57,0,0,1,.21-.26Z",
    style: {
      fill: "rgb(234, 57, 93)",
      transformOrigin: "297.895px 153.143px"
    },
    id: "ela2b5mhwdqs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.89,149.52a.17.17,0,0,1,.22,0,.38.38,0,0,1,.09.28v1.69a.85.85,0,0,1-.09.38.56.56,0,0,1-.22.27l-1,.6a.18.18,0,0,1-.22,0,.38.38,0,0,1-.09-.28v-1.7a.92.92,0,0,1,.09-.38.53.53,0,0,1,.22-.26Z",
    style: {
      fill: "rgb(234, 57, 93)",
      transformOrigin: "301.39px 151.129px"
    },
    id: "el2mw220jjmgd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.39,147.5a.15.15,0,0,1,.21,0,.38.38,0,0,1,.09.28v1.69a.92.92,0,0,1-.09.39.63.63,0,0,1-.21.26l-1.05.6a.16.16,0,0,1-.21,0,.38.38,0,0,1-.09-.28v-1.7a.92.92,0,0,1,.09-.38.63.63,0,0,1,.21-.26Z",
    style: {
      fill: "rgb(234, 57, 93)",
      transformOrigin: "304.865px 149.108px"
    },
    id: "elmbcsuhedcql",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.18,171.9l51.24-29.58c.61-.35,1.1-.1,1.1.55a2.34,2.34,0,0,1-1.1,1.82l-51.24,29.59c-.61.35-1.1.1-1.1-.56A2.35,2.35,0,0,1,279.18,171.9Z",
    style: {
      fill: "rgb(234, 57, 93)",
      transformOrigin: "304.8px 158.3px"
    },
    id: "elhix0f0txvda",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.62,190.89l51.24-29.59c.61-.35,1.1-.1,1.1.56a2.35,2.35,0,0,1-1.1,1.82l-51.24,29.58c-.61.35-1.1.1-1.1-.55A2.34,2.34,0,0,1,295.62,190.89Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "321.24px 177.28px"
    },
    id: "elno96mg3do7b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.62,200.38l24.53-14.15c.6-.35,1.09-.1,1.09.56a2.33,2.33,0,0,1-1.09,1.81l-24.53,14.16c-.61.34-1.1.1-1.1-.56A2.35,2.35,0,0,1,295.62,200.38Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "307.88px 194.493px"
    },
    id: "el67c08wmtzay",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.62,209.87l24.53-14.15c.6-.34,1.09-.1,1.09.56a2.37,2.37,0,0,1-1.09,1.82l-24.53,14.15c-.61.35-1.1.1-1.1-.56A2.35,2.35,0,0,1,295.62,209.87Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "307.88px 203.987px"
    },
    id: "el7i40rnr16o7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.67,139.87,355.08,128c.61-.35,1.1-.1,1.1.55a2.34,2.34,0,0,1-1.1,1.82l-20.41,11.83c-.61.35-1.1.1-1.1-.55A2.34,2.34,0,0,1,334.67,139.87Z",
    style: {
      fill: "rgb(234, 57, 93)",
      transformOrigin: "344.875px 135.1px"
    },
    id: "elfagcpfzm01u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.18,276.31l51.24-29.58c.61-.35,1.1-.1,1.1.55a2.34,2.34,0,0,1-1.1,1.82l-51.24,29.59c-.61.34-1.1.1-1.1-.56A2.35,2.35,0,0,1,279.18,276.31Z",
    style: {
      fill: "rgb(234, 57, 93)",
      transformOrigin: "304.8px 262.708px"
    },
    id: "elvda5epyfkn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.67,244.27l20.41-11.83c.61-.35,1.1-.1,1.1.56a2.35,2.35,0,0,1-1.1,1.82l-20.41,11.83c-.61.35-1.1.1-1.1-.56A2.35,2.35,0,0,1,334.67,244.27Z",
    style: {
      fill: "rgb(234, 57, 93)",
      transformOrigin: "344.875px 239.545px"
    },
    id: "elr09zan2w1pa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.67,215.85,355.08,204c.61-.35,1.1-.1,1.1.55a2.34,2.34,0,0,1-1.1,1.82l-20.41,11.83c-.61.35-1.1.1-1.1-.55A2.34,2.34,0,0,1,334.67,215.85Z",
    style: {
      fill: "rgb(234, 57, 93)",
      transformOrigin: "344.875px 211.1px"
    },
    id: "elmajlsxb9r1h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.67,225.34l20.41-11.83c.61-.35,1.1-.1,1.1.55a2.34,2.34,0,0,1-1.1,1.82l-20.41,11.83c-.61.35-1.1.1-1.1-.55A2.34,2.34,0,0,1,334.67,225.34Z",
    style: {
      fill: "rgb(234, 57, 93)",
      transformOrigin: "344.875px 220.61px"
    },
    id: "elr8blaebone8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.18,266.83l51.24-29.59c.61-.34,1.1-.1,1.1.56a2.35,2.35,0,0,1-1.1,1.82L279.18,269.2c-.61.35-1.1.1-1.1-.55A2.34,2.34,0,0,1,279.18,266.83Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "304.8px 253.222px"
    },
    id: "elc07is38a9ft",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.26,225.87l11.47-6.62c.6-.35,1.09-.1,1.09.55a2.35,2.35,0,0,1-1.09,1.82l-11.47,6.62c-.61.35-1.1.11-1.1-.55A2.34,2.34,0,0,1,317.26,225.87Z",
    style: {
      fill: "rgb(234, 57, 93)",
      transformOrigin: "322.99px 223.746px"
    },
    id: "el0rf7ebjaqsf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.18,181.42l29.89-17.27c.6-.35,1.09-.1,1.09.55a2.35,2.35,0,0,1-1.09,1.82l-29.89,17.27c-.61.35-1.1.1-1.1-.55A2.34,2.34,0,0,1,279.18,181.42Z",
    style: {
      fill: "rgb(234, 57, 93)",
      transformOrigin: "294.12px 173.97px"
    },
    id: "elnjw8dw59ctf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elhooj12zadjn"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M279.18,181.42l29.89-17.27c.6-.35,1.09-.1,1.09.55a2.35,2.35,0,0,1-1.09,1.82l-29.89,17.27c-.61.35-1.1.1-1.1-.55A2.34,2.34,0,0,1,279.18,181.42Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      transformOrigin: "294.12px 173.97px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M279.18,190.89,289.32,185c.6-.35,1.09-.1,1.09.56a2.37,2.37,0,0,1-1.09,1.82l-10.14,5.86c-.61.35-1.1.1-1.1-.56A2.35,2.35,0,0,1,279.18,190.89Z",
    style: {
      fill: "rgb(234, 57, 93)",
      transformOrigin: "284.245px 189.12px"
    },
    id: "el2j1on790jsi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elydkpin4y5cs"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M279.18,190.89,289.32,185c.6-.35,1.09-.1,1.09.56a2.37,2.37,0,0,1-1.09,1.82l-10.14,5.86c-.61.35-1.1.1-1.1-.56A2.35,2.35,0,0,1,279.18,190.89Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      transformOrigin: "284.245px 189.12px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M279.18,200.39l10.14-5.87c.6-.35,1.09-.1,1.09.56a2.37,2.37,0,0,1-1.09,1.82l-10.14,5.86c-.61.35-1.1.1-1.1-.56A2.32,2.32,0,0,1,279.18,200.39Z",
    style: {
      fill: "rgb(234, 57, 93)",
      transformOrigin: "284.245px 198.64px"
    },
    id: "eln74iz7qv1y",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elw0cnd4kjtxa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M279.18,200.39l10.14-5.87c.6-.35,1.09-.1,1.09.56a2.37,2.37,0,0,1-1.09,1.82l-10.14,5.86c-.61.35-1.1.1-1.1-.56A2.32,2.32,0,0,1,279.18,200.39Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      transformOrigin: "284.245px 198.64px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M279.18,209.88,289.32,204c.6-.35,1.09-.11,1.09.55a2.35,2.35,0,0,1-1.09,1.82l-10.14,5.86c-.61.35-1.1.1-1.1-.55A2.34,2.34,0,0,1,279.18,209.88Z",
    style: {
      fill: "rgb(234, 57, 93)",
      transformOrigin: "284.245px 208.114px"
    },
    id: "elinhtp2mvh0l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elbuakd5acw1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M279.18,209.88,289.32,204c.6-.35,1.09-.11,1.09.55a2.35,2.35,0,0,1-1.09,1.82l-10.14,5.86c-.61.35-1.1.1-1.1-.55A2.34,2.34,0,0,1,279.18,209.88Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      transformOrigin: "284.245px 208.114px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M279.18,219.37l10.14-5.86c.6-.35,1.09-.1,1.09.55a2.35,2.35,0,0,1-1.09,1.82l-10.14,5.86c-.61.35-1.1.1-1.1-.55A2.34,2.34,0,0,1,279.18,219.37Z",
    style: {
      fill: "rgb(234, 57, 93)",
      transformOrigin: "284.245px 217.625px"
    },
    id: "elpzehsaqz6h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el7dorj6fdn7y"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M279.18,219.37l10.14-5.86c.6-.35,1.09-.1,1.09.55a2.35,2.35,0,0,1-1.09,1.82l-10.14,5.86c-.61.35-1.1.1-1.1-.55A2.34,2.34,0,0,1,279.18,219.37Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      transformOrigin: "284.245px 217.625px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M313.31,161.7l13-7.48c.6-.35,1.1-.1,1.1.55a2.36,2.36,0,0,1-1.1,1.82l-13,7.48c-.6.35-1.09.1-1.09-.55A2.35,2.35,0,0,1,313.31,161.7Z",
    style: {
      fill: "rgb(234, 57, 93)",
      transformOrigin: "319.815px 159.145px"
    },
    id: "el07karm3sl3ha",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ela1srqp1so4p"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M313.31,161.7l13-7.48c.6-.35,1.1-.1,1.1.55a2.36,2.36,0,0,1-1.1,1.82l-13,7.48c-.6.35-1.09.1-1.09-.55A2.35,2.35,0,0,1,313.31,161.7Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      transformOrigin: "319.815px 159.145px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M308,212.23,337.84,195c.6-.35,1.09-.1,1.09.56a2.37,2.37,0,0,1-1.09,1.82L308,214.61c-.6.35-1.1.1-1.1-.56A2.35,2.35,0,0,1,308,212.23Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "322.915px 204.805px"
    },
    id: "elsjq15u9w3fs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.19,211.81l29.89-17.27c.61-.35,1.1-.1,1.1.55a2.34,2.34,0,0,1-1.1,1.82l-29.89,17.27c-.6.35-1.09.1-1.09-.55A2.35,2.35,0,0,1,325.19,211.81Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "340.14px 204.36px"
    },
    id: "eltdpu627fnyq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.09,192.51l13-7.48c.61-.35,1.1-.1,1.1.56a2.35,2.35,0,0,1-1.1,1.82l-13,7.48c-.61.34-1.1.1-1.1-.56A2.35,2.35,0,0,1,342.09,192.51Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "348.59px 189.958px"
    },
    id: "elet9pduv1x5w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.62,181.4l29.89-17.27c.6-.35,1.09-.1,1.09.56a2.37,2.37,0,0,1-1.09,1.82l-29.89,17.26c-.61.35-1.1.11-1.1-.55A2.35,2.35,0,0,1,295.62,181.4Z",
    style: {
      fill: "rgb(234, 57, 93)",
      transformOrigin: "310.56px 173.951px"
    },
    id: "elgbuqfyc73vh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eloph3idq2a2q"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M295.62,181.4l29.89-17.27c.6-.35,1.09-.1,1.09.56a2.37,2.37,0,0,1-1.09,1.82l-29.89,17.26c-.61.35-1.1.11-1.1-.55A2.35,2.35,0,0,1,295.62,181.4Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      transformOrigin: "310.56px 173.951px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M329.75,161.68l13-7.48c.61-.35,1.1-.1,1.1.55a2.34,2.34,0,0,1-1.1,1.82l-13,7.48c-.6.35-1.09.1-1.09-.55A2.35,2.35,0,0,1,329.75,161.68Z",
    style: {
      fill: "rgb(234, 57, 93)",
      transformOrigin: "336.255px 159.125px"
    },
    id: "elytvro4akq9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elo07vfxlz7w9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M329.75,161.68l13-7.48c.61-.35,1.1-.1,1.1.55a2.34,2.34,0,0,1-1.1,1.82l-13,7.48c-.6.35-1.09.1-1.09-.55A2.35,2.35,0,0,1,329.75,161.68Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      transformOrigin: "336.255px 159.125px"
    },
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubbles--inject-14",
    className: "animable",
    style: {
      transformOrigin: "433.833px 166.723px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M425.21,95.43V84l-9.61-.83a.59.59,0,0,0-.4.08c-.38.2-9.48,5.41-9.59,5.48a.7.7,0,0,0-.16,1.08l10.19,11.05Z",
    style: {
      fill: "rgb(234, 57, 93)",
      transformOrigin: "415.237px 92.0114px"
    },
    id: "eltozj2v8w24",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.64,100.9,405.45,89.85a.71.71,0,0,1,.58-1.18l9.61.84Z",
    style: {
      fill: "rgb(234, 57, 93)",
      transformOrigin: "410.455px 94.7841px"
    },
    id: "elqpxku94221n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.2,84l-9.56,5.48L406,88.67a.93.93,0,0,0-.34,0c.77-.45,9.16-5.25,9.5-5.43a.64.64,0,0,1,.41-.08Z",
    style: {
      fill: "rgb(234, 57, 93)",
      transformOrigin: "415.43px 86.3169px"
    },
    id: "el7bb95swutqh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elnjwpg3ytbsk"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M425.2,84l-9.56,5.48L406,88.67a.93.93,0,0,0-.34,0c.77-.45,9.16-5.25,9.5-5.43a.64.64,0,0,1,.41-.08Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "415.43px 86.3169px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M415.66,76.67a7.69,7.69,0,0,1,3.46-6L421.94,69a7.63,7.63,0,0,1,6.93,0L458.94,86.4a7.64,7.64,0,0,1,3.47,6v34.74a7.65,7.65,0,0,1-3.47,6l-2.82,1.63a7.69,7.69,0,0,1-6.93,0l-8.87-5.13L428.78,123l-9.66-5.58a7.65,7.65,0,0,1-3.46-6Z",
    style: {
      fill: "rgb(234, 57, 93)",
      transformOrigin: "439.035px 101.881px"
    },
    id: "elryynkma033c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elt7xtl3h67es"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M462.41,127.14a7.65,7.65,0,0,1-3.47,6l-2.82,1.63a7.77,7.77,0,0,1-6.34.28c1.64.61,2.88-.31,2.88-2.28V98a7.07,7.07,0,0,0-1-3.42L461.39,89a7.07,7.07,0,0,1,1,3.42Z",
    style: {
      opacity: 0.2,
      transformOrigin: "456.095px 112.297px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el98r61xjo1o"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M415.77,75.68c.41-1.47,1.75-1.94,3.35-1L449.2,92a6.94,6.94,0,0,1,2.44,2.59L461.38,89a6.91,6.91,0,0,0-2.44-2.58L428.88,69A7.69,7.69,0,0,0,422,69l-2.83,1.63A7.67,7.67,0,0,0,415.77,75.68Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "438.575px 81.3888px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "434.16 89.35 422.71 87.75 424.31 108.88 434.16 121.67 434.16 89.35",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "428.435px 104.71px"
    },
    id: "elagc8gk17d85",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "434.16 89.35 445.61 100.98 444 120.25 434.16 121.67 434.16 89.35",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "439.885px 105.51px"
    },
    id: "elw3d5m8q7nnl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.87,116.84l2.63,1.52-7.32-25.79-7.31,17.34,2.62,1.52,1.58-3.76,6.22,3.59ZM432,105.4l2.16-5.14,2.16,7.64Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "434.185px 105.465px"
    },
    id: "elffi4qy0mmih",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.21,160.27V148.89l-9.61-.84a.74.74,0,0,0-.4.08c-.38.2-9.48,5.41-9.59,5.48a.71.71,0,0,0-.16,1.09l10.19,11Z",
    style: {
      fill: "rgb(234, 57, 93)",
      transformOrigin: "415.237px 156.874px"
    },
    id: "el1l88jzj157q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.64,165.74l-10.19-11a.7.7,0,0,1,.58-1.18l9.61.84Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "410.448px 159.648px"
    },
    id: "elauybi2bndvc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.2,148.88l-9.56,5.48-9.61-.84a.76.76,0,0,0-.34,0c.77-.46,9.16-5.25,9.5-5.44a.71.71,0,0,1,.41-.08Z",
    style: {
      fill: "rgb(234, 57, 93)",
      transformOrigin: "415.445px 151.178px"
    },
    id: "el0n1uqwkuxys",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.2,148.88l-9.56,5.48-9.61-.84a.76.76,0,0,0-.34,0c.77-.46,9.16-5.25,9.5-5.44a.71.71,0,0,1,.41-.08Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "415.445px 151.178px"
    },
    id: "eled7ggbthr3k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.66,141.51a7.65,7.65,0,0,1,3.46-6l2.82-1.63a7.63,7.63,0,0,1,6.93,0l30.07,17.36a7.65,7.65,0,0,1,3.47,6V192a7.64,7.64,0,0,1-3.47,6l-2.82,1.63a7.63,7.63,0,0,1-6.93,0l-8.87-5.12-11.54-6.67-9.66-5.57a7.67,7.67,0,0,1-3.46-6Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "439.035px 166.755px"
    },
    id: "elo2qc30c30b9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.41,192a7.64,7.64,0,0,1-3.47,6l-2.82,1.63a7.73,7.73,0,0,1-6.34.28c1.64.62,2.88-.3,2.88-2.28V162.87a7,7,0,0,0-1-3.41l9.75-5.63a7,7,0,0,1,1,3.41Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "456.095px 177.144px"
    },
    id: "eluuq4sp59gu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.77,140.52c.41-1.47,1.75-1.94,3.35-1l30.08,17.36a6.94,6.94,0,0,1,2.44,2.59l9.74-5.62a6.94,6.94,0,0,0-2.44-2.59l-30.06-17.37a7.69,7.69,0,0,0-6.93,0l-2.83,1.63A7.67,7.67,0,0,0,415.77,140.52Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "438.575px 146.268px"
    },
    id: "elda7c8ndfucs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "434.16 162.75 436.68 157.99 445.61 163.15 434.16 184.68 422.71 149.92 431.63 155.07 434.16 162.75",
    style: {
      fill: "rgb(234, 57, 93)",
      transformOrigin: "434.16px 167.3px"
    },
    id: "el5edo235zrbb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el9z5j1875kp"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "434.16 162.75 436.68 157.99 445.61 163.15 434.16 184.68 422.71 149.92 431.63 155.07 434.16 162.75",
    style: {
      opacity: 0.15,
      transformOrigin: "434.16px 167.3px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M434.16,162.75l-2.53-7.67-4-2.3c3.19,9.69,6.51,19.75,6.51,19.75l6.5-12.24-4-2.3Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "434.135px 162.655px"
    },
    id: "elxkb4qbd0xd9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.21,225.12V213.73l-9.61-.84a.74.74,0,0,0-.4.08l-9.59,5.48a.71.71,0,0,0-.16,1.09l10.19,11Z",
    style: {
      fill: "rgb(234, 57, 93)",
      transformOrigin: "415.237px 221.714px"
    },
    id: "elj6sszjjvkmo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.64,230.58l-10.19-11a.7.7,0,0,1,.58-1.18l9.61.84Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "410.448px 224.488px"
    },
    id: "elkw9cdze6szr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.2,213.73l-9.56,5.47-9.61-.84a.76.76,0,0,0-.34,0l9.5-5.44a.79.79,0,0,1,.41-.08Z",
    style: {
      fill: "rgb(234, 57, 93)",
      transformOrigin: "415.445px 216.019px"
    },
    id: "elynvuabnz0n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.2,213.73l-9.56,5.47-9.61-.84a.76.76,0,0,0-.34,0l9.5-5.44a.79.79,0,0,1,.41-.08Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "415.445px 216.019px"
    },
    id: "el0qaq6hcf19sf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.66,206.35a7.67,7.67,0,0,1,3.46-6l2.82-1.63a7.69,7.69,0,0,1,6.93,0l30.07,17.36a7.67,7.67,0,0,1,3.47,6v34.73a7.64,7.64,0,0,1-3.47,6l-2.82,1.63a7.63,7.63,0,0,1-6.93,0l-8.87-5.12-11.54-6.67-9.66-5.57a7.65,7.65,0,0,1-3.46-6Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "439.035px 231.584px"
    },
    id: "el9go7b316hrg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.41,256.82a7.64,7.64,0,0,1-3.47,6l-2.82,1.63a7.73,7.73,0,0,1-6.34.28c1.64.62,2.88-.3,2.88-2.28V227.72a7.07,7.07,0,0,0-1-3.42l9.75-5.63a7.07,7.07,0,0,1,1,3.42Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "456.095px 241.974px"
    },
    id: "elwf1y8poedwf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.77,205.37c.41-1.47,1.75-1.94,3.35-1l30.08,17.37a6.91,6.91,0,0,1,2.44,2.58l9.74-5.62a6.94,6.94,0,0,0-2.44-2.59l-30.06-17.37a7.69,7.69,0,0,0-6.93,0l-2.83,1.64A7.64,7.64,0,0,0,415.77,205.37Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "438.575px 211.118px"
    },
    id: "elc2v41h5u958",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.85,232.89c.71-3.6.42-6.91-1-8.79a3.33,3.33,0,0,0-2.72-1.44h-.25a5.44,5.44,0,0,0-2.65,1c-2-3.78-4-6.1-5.43-6.1h-.21a1.28,1.28,0,0,0-.9.68c-.69,1.15-.73,3.64-.21,6.91a5.53,5.53,0,0,0-3.74.27,2.35,2.35,0,0,0-1.16,2.18c0,2.17,1.91,5.15,4.88,8-.71,3.6-.42,6.91,1,8.79a3.87,3.87,0,0,0,1.13,1,3.11,3.11,0,0,0,1.58.42,4,4,0,0,0,1.06-.15,6.47,6.47,0,0,0,1.91-1c1.61,3,3.22,5.17,4.51,5.92a2,2,0,0,0,1,.3.68.68,0,0,0,.2,0,1.3,1.3,0,0,0,.91-.68c.69-1.15.72-3.64.2-6.93a9.31,9.31,0,0,0,1.59.16,4.07,4.07,0,0,0,2.05-.46,2.36,2.36,0,0,0,1.16-2.18C445.73,238.71,443.82,235.73,440.85,232.89Zm-3.43,5.79a19.44,19.44,0,0,1-1.1,1.75c-.66-.32-1.36-.68-2.1-1.11s-1.45-.87-2.12-1.33c-.39-1-.78-2.06-1.15-3.16s-.69-2.12-1-3.12c.28-.62.58-1.24.92-1.85s.72-1.21,1.09-1.75c.67.32,1.37.68,2.11,1.11s1.52.92,2.23,1.4c.39,1,.77,2,1.15,3.15s.65,2,.92,2.94C438.11,237.36,437.78,238,437.42,238.68Zm1-5.11c-.22-.66-.45-1.31-.68-1.94.67.5,1.3,1,1.89,1.54-.18.69-.39,1.4-.65,2.11C438.78,234.72,438.6,234.15,438.4,233.57Zm-4.18-5.64q-.77-.44-1.5-.81a12.89,12.89,0,0,1,1.42-1.5c.47.95.95,2,1.43,3.13C435.13,228.47,434.68,228.19,434.22,227.93Zm-4.25.88c-.18.33-.36.66-.52,1-.27-1.05-.5-2-.68-2.95a18.74,18.74,0,0,1,2,.69C430.47,228,430.21,228.37,430,228.81Zm0,6.22c.23.67.46,1.32.7,2-.71-.53-1.38-1.08-2-1.63a23.15,23.15,0,0,1,.7-2.25C429.59,233.75,429.79,234.38,430,235Zm4.08,5.58c.51.29,1,.55,1.49.8a12.74,12.74,0,0,1-1.35,1.45c-.46-.92-.92-1.92-1.37-3C433.26,240.11,433.67,240.37,434.09,240.61Zm4.25-.88c.21-.37.4-.74.58-1.12.29,1.1.53,2.14.72,3.1a18.34,18.34,0,0,1-2.06-.72C437.84,240.59,438.1,240.17,438.34,239.73Zm-1.36-10c-.67-1.71-1.37-3.28-2.07-4.69a5.35,5.35,0,0,1,1.67-.84,3.23,3.23,0,0,1,.85-.12,2.21,2.21,0,0,1,1.15.29,2.43,2.43,0,0,1,.68.61c.95,1.26,1.21,3.91.61,7A35.8,35.8,0,0,0,437,229.71Zm-5.53-3.19a21.23,21.23,0,0,0-2.93-1.07c-.5-3.1-.44-5.23.06-6.06A.65.65,0,0,1,429,219h.09a1.08,1.08,0,0,1,.54.18c.95.55,2.32,2.33,3.81,5.11A13.69,13.69,0,0,0,431.45,226.52Zm-2.62,4.67a23,23,0,0,0-1.11,3.28c-2.56-2.48-4.09-4.88-4.09-6.35a1.46,1.46,0,0,1,.76-1.34,3.47,3.47,0,0,1,1.7-.36,8.1,8.1,0,0,1,1.64.19C428,228,428.37,229.56,428.83,231.19Zm2.61,7.72c.66,1.64,1.34,3.17,2,4.57a4.78,4.78,0,0,1-2.4,1,2.21,2.21,0,0,1-2-.89c-.95-1.27-1.21-3.92-.61-7A34.32,34.32,0,0,0,431.44,238.91Zm5.42,3.11a20.55,20.55,0,0,0,3,1.1c.51,3.11.45,5.25-.05,6.09a.69.69,0,0,1-.45.36c-.91.16-2.62-1.87-4.49-5.4A13.36,13.36,0,0,0,436.86,242Zm2.68-4.8a23.74,23.74,0,0,0,1-3.15c2.56,2.48,4.09,4.88,4.09,6.35a1.48,1.48,0,0,1-.76,1.34,5,5,0,0,1-3.24.19C440.4,240.49,440,238.9,439.54,237.22Z",
    style: {
      fill: "rgb(234, 57, 93)",
      transformOrigin: "434.17px 234.224px"
    },
    id: "elqtg6mw2a7qh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.19,235.44c0,1.5-.91,2.19-2,1.54a4.86,4.86,0,0,1-2-3.89c0-1.49.91-2.18,2-1.53A4.86,4.86,0,0,1,436.19,235.44Z",
    style: {
      fill: "rgb(234, 57, 93)",
      transformOrigin: "434.19px 234.27px"
    },
    id: "elc8fy5l4x3tl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eltr7uvisjtj9"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.65,
      transformOrigin: "434.17px 234.224px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M440.85,232.89c.71-3.6.42-6.91-1-8.79a3.33,3.33,0,0,0-2.72-1.44h-.25a5.44,5.44,0,0,0-2.65,1c-2-3.78-4-6.1-5.43-6.1h-.21a1.28,1.28,0,0,0-.9.68c-.69,1.15-.73,3.64-.21,6.91a5.53,5.53,0,0,0-3.74.27,2.35,2.35,0,0,0-1.16,2.18c0,2.17,1.91,5.15,4.88,8-.71,3.6-.42,6.91,1,8.79a3.87,3.87,0,0,0,1.13,1,3.11,3.11,0,0,0,1.58.42,4,4,0,0,0,1.06-.15,6.47,6.47,0,0,0,1.91-1c1.61,3,3.22,5.17,4.51,5.92a2,2,0,0,0,1,.3.68.68,0,0,0,.2,0,1.3,1.3,0,0,0,.91-.68c.69-1.15.72-3.64.2-6.93a9.31,9.31,0,0,0,1.59.16,4.07,4.07,0,0,0,2.05-.46,2.36,2.36,0,0,0,1.16-2.18C445.73,238.71,443.82,235.73,440.85,232.89Zm-3.43,5.79a19.44,19.44,0,0,1-1.1,1.75c-.66-.32-1.36-.68-2.1-1.11s-1.45-.87-2.12-1.33c-.39-1-.78-2.06-1.15-3.16s-.69-2.12-1-3.12c.28-.62.58-1.24.92-1.85s.72-1.21,1.09-1.75c.67.32,1.37.68,2.11,1.11s1.52.92,2.23,1.4c.39,1,.77,2,1.15,3.15s.65,2,.92,2.94C438.11,237.36,437.78,238,437.42,238.68Zm1-5.11c-.22-.66-.45-1.31-.68-1.94.67.5,1.3,1,1.89,1.54-.18.69-.39,1.4-.65,2.11C438.78,234.72,438.6,234.15,438.4,233.57Zm-4.18-5.64q-.77-.44-1.5-.81a12.89,12.89,0,0,1,1.42-1.5c.47.95.95,2,1.43,3.13C435.13,228.47,434.68,228.19,434.22,227.93Zm-4.25.88c-.18.33-.36.66-.52,1-.27-1.05-.5-2-.68-2.95a18.74,18.74,0,0,1,2,.69C430.47,228,430.21,228.37,430,228.81Zm0,6.22c.23.67.46,1.32.7,2-.71-.53-1.38-1.08-2-1.63a23.15,23.15,0,0,1,.7-2.25C429.59,233.75,429.79,234.38,430,235Zm4.08,5.58c.51.29,1,.55,1.49.8a12.74,12.74,0,0,1-1.35,1.45c-.46-.92-.92-1.92-1.37-3C433.26,240.11,433.67,240.37,434.09,240.61Zm4.25-.88c.21-.37.4-.74.58-1.12.29,1.1.53,2.14.72,3.1a18.34,18.34,0,0,1-2.06-.72C437.84,240.59,438.1,240.17,438.34,239.73Zm-1.36-10c-.67-1.71-1.37-3.28-2.07-4.69a5.35,5.35,0,0,1,1.67-.84,3.23,3.23,0,0,1,.85-.12,2.21,2.21,0,0,1,1.15.29,2.43,2.43,0,0,1,.68.61c.95,1.26,1.21,3.91.61,7A35.8,35.8,0,0,0,437,229.71Zm-5.53-3.19a21.23,21.23,0,0,0-2.93-1.07c-.5-3.1-.44-5.23.06-6.06A.65.65,0,0,1,429,219h.09a1.08,1.08,0,0,1,.54.18c.95.55,2.32,2.33,3.81,5.11A13.69,13.69,0,0,0,431.45,226.52Zm-2.62,4.67a23,23,0,0,0-1.11,3.28c-2.56-2.48-4.09-4.88-4.09-6.35a1.46,1.46,0,0,1,.76-1.34,3.47,3.47,0,0,1,1.7-.36,8.1,8.1,0,0,1,1.64.19C428,228,428.37,229.56,428.83,231.19Zm2.61,7.72c.66,1.64,1.34,3.17,2,4.57a4.78,4.78,0,0,1-2.4,1,2.21,2.21,0,0,1-2-.89c-.95-1.27-1.21-3.92-.61-7A34.32,34.32,0,0,0,431.44,238.91Zm5.42,3.11a20.55,20.55,0,0,0,3,1.1c.51,3.11.45,5.25-.05,6.09a.69.69,0,0,1-.45.36c-.91.16-2.62-1.87-4.49-5.4A13.36,13.36,0,0,0,436.86,242Zm2.68-4.8a23.74,23.74,0,0,0,1-3.15c2.56,2.48,4.09,4.88,4.09,6.35a1.48,1.48,0,0,1-.76,1.34,5,5,0,0,1-3.24.19C440.4,240.49,440,238.9,439.54,237.22Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "434.17px 234.224px"
    },
    id: "elvjicvw4mmzq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.19,235.44c0,1.5-.91,2.19-2,1.54a4.86,4.86,0,0,1-2-3.89c0-1.49.91-2.18,2-1.53A4.86,4.86,0,0,1,436.19,235.44Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "434.19px 234.27px"
    },
    id: "elyn9b3vg1g5b",
    className: "animable"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-14",
    className: "animable animator-hidden",
    style: {
      transformOrigin: "370.422px 333.157px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-14",
    className: "animable",
    style: {
      transformOrigin: "370.422px 333.157px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M393.11,274.22c3.91.76,5.69,2.09,7.91,7.51s6.19,18.62,7.11,22.25c.42,1.62-9.85,16.14-9.41,15.92.13-.06-4-7-4-7l5.05-9.64-3.59-8.78Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "400.626px 297.061px"
    },
    id: "elnzc0b1a32q8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.79,274.3s3.56-.64,5.92,1.32,2.72,3.27,4.32,7.29,4.22,12.4,4.22,12.4-.76,4.5-8.09,5.39l-6.28-14.15S389.69,278,391.79,274.3Z",
    style: {
      fill: "rgb(234, 57, 93)",
      transformOrigin: "398.565px 287.45px"
    },
    id: "elwtai9phy67",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.43,390.41a8.32,8.32,0,0,0,.23,3.81,8.54,8.54,0,0,0,3.08,3.71,15.27,15.27,0,0,1,2.56,3.1,12.8,12.8,0,0,0,2.67,3.34c.83.72,3.18.79,4.31.31s1.52-.9,1.45-2.71-5.56-2.43-5.56-2.43Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "391.523px 397.698px"
    },
    id: "el1m6yipbtuzv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398,396.58c.46.17.58,1.06.65,2.84.06,1.34.62,3.3-1.23,4.14a4.51,4.51,0,0,1-4.87-1c-1.26-1.58-2.11-3-3.9-4.89-1.56-1.67-3.17-2.23-3.87-5.57-.44-2.14-.09-3,1.35-3.65,2-.84,5.11,1.92,6.66,2.35C394.15,391.15,397.55,396.4,398,396.58Z",
    style: {
      fill: "rgb(234, 57, 93)",
      transformOrigin: "391.689px 396.088px"
    },
    id: "el73qk6k5yll3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el2muc2g3ovcf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M398,396.58c.46.17.58,1.06.65,2.84.06,1.34.62,3.3-1.23,4.14a4.51,4.51,0,0,1-4.87-1c-1.26-1.58-2.11-3-3.9-4.89-1.56-1.67-3.17-2.23-3.87-5.57-.44-2.14-.09-3,1.35-3.65,2-.84,5.11,1.92,6.66,2.35C394.15,391.15,397.55,396.4,398,396.58Z",
    style: {
      opacity: 0.2,
      transformOrigin: "391.689px 396.088px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M392.81,390.77l-.26-.09a5.11,5.11,0,0,0-4.3,2.82c-.26.59.55,1,1,.59a5.46,5.46,0,0,1,4.29-2.81A2.3,2.3,0,0,0,392.81,390.77Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "390.87px 392.468px"
    },
    id: "elt87emju9zw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.09,391.78a5.09,5.09,0,0,0-4,2.8c-.26.58.55,1,1,.58a5.27,5.27,0,0,1,3.58-2.67C394.51,392.24,394.3,392,394.09,391.78Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "392.355px 393.555px"
    },
    id: "el9mnq8ogse1o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.48,417.82c-.3,1.5.24,2.28,2.18,3.4a10.81,10.81,0,0,0,8.18.57c3.2-.93,4.73-2.32,6.06-2.66s4.62-.36,5.93-.74,1.29-1.06,1.29-2.64Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "371.261px 419.043px"
    },
    id: "elbobdr9irqu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.83,408.13s.62,1.9,1,3.55c.27,1.32.65,3.51.19,4.5s-2.26,1.63-5,1.61c-1.8,0-4.62,1.21-6.54,2.28a10,10,0,0,1-6.25.87c-2.48-.29-5-1.73-5.44-2.75s-.51-1.8,5.33-4.29c.06,0,6.78-2.5,9.6-5.62Z",
    style: {
      fill: "rgb(234, 57, 93)",
      transformOrigin: "371.424px 414.618px"
    },
    id: "els7cej6ncs6f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el3j3vp608n4b"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "371.424px 414.618px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M381.83,408.13s.62,1.9,1,3.55c.27,1.32.65,3.51.19,4.5s-2.26,1.63-5,1.61c-1.8,0-4.62,1.21-6.54,2.28a10,10,0,0,1-6.25.87c-2.48-.29-5-1.73-5.44-2.75s-.51-1.8,5.33-4.29c.06,0,6.78-2.5,9.6-5.62Z",
    id: "el8n1j8tepbki",
    className: "animable",
    style: {
      transformOrigin: "371.424px 414.618px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M370.6,420.46s-.5-5-4.57-6.45c-3.69-1.3-6.9,1.43-6.55,3.81C359.72,419.41,364.21,423,370.6,420.46Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "365.027px 417.508px"
    },
    id: "eldq6key0fqo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.06,413.07a4.74,4.74,0,0,1,2.78,1.24c1.18,1,1.21,1.64,1.21,1.64a.62.62,0,0,0,1.06-.51s-.27-2.53-3.6-3A1.35,1.35,0,0,0,367.06,413.07Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "369.587px 414.274px"
    },
    id: "ely0sj8z4ozlm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.39,412a4.16,4.16,0,0,1,2.81,1.12c1.17,1,1.18,1.77,1.18,1.77a.62.62,0,0,0,1.06-.51s-.27-2.53-3.6-3.05A1.35,1.35,0,0,0,369.39,412Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "371.917px 413.191px"
    },
    id: "ely9cywyrwnv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.7,410.63a4.16,4.16,0,0,1,2.88.93c1.24.9,1.3,1.68,1.3,1.68a.62.62,0,0,0,1-.58s-.45-2.51-3.81-2.8A1.36,1.36,0,0,0,371.7,410.63Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "374.294px 411.614px"
    },
    id: "el5ztzx6e36nq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398,393.71v3.4a5.33,5.33,0,0,1-5.5.15c-.1-.21-.37-3.55-.37-3.55Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "395.065px 395.831px"
    },
    id: "ela5e9f8oolw4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.83,405.78s0,1.62,0,2.54-1.08,2.3-3.9,2.2c-2-.07-3.36-.61-3.29-2.24v-2.35Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "378.234px 408.153px"
    },
    id: "elbs2s4h2f8nv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.68,364.85c-.18-7.18-1.65-10.33-1.65-10.33s.54-8.86,1.74-19.71c1.81-16.51,1-19.71-2.28-27.15,0,0-27.81-2.81-28.65,8.74-1.06,14.39-1.18,43.66-.8,48.74s.37.39,1.61,10.68c1,8.14,3,30.11,3,30.11a7.65,7.65,0,0,0,7.19-.15s2.27-26.88,2-32.75a67.27,67.27,0,0,0-.69-9s3.25-23.19,3.75-26.92c0,0,.45,6.68.84,11.76s.35,9.18,1.42,19.69c.84,8.25,2.87,26.06,2.87,26.06a6.86,6.86,0,0,0,6.07-.45S401.83,370.65,401.68,364.85Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "386.279px 357.057px"
    },
    id: "elsduf82jglhl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.72,394.54s.15-4,5.52-4.52l.31.17a4.65,4.65,0,0,0-2.64-2,3.65,3.65,0,0,0-4.13,1.19C383.84,390.55,384.79,393.77,385.72,394.54Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "387.971px 391.255px"
    },
    id: "elwykhq9uxvp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "378.87 270.48 380.18 281.22 389.62 280.37 388.55 268.44 378.87 270.48",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "384.245px 274.83px"
    },
    id: "elmeoiw9svmlr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.84,279.41c-1-2.82-3.42-5.78-7-5.11-1,.18-1.78.31-2.67.49-.08,2.48-4.75,3.76-9.39,2.26-1.4.4-2.68.81-3.84,1.22-3.33,1.19-4.66,6.71-4.74,16S369.78,322,369.78,322s7,3.71,20.07,1.34,12.86-6.82,12.86-6.82-.26-5.42-6.16-14.52C401.56,288.69,400.38,283.61,398.84,279.41Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "386.245px 299.168px"
    },
    id: "elo05fbtfxha",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.85,256.83a8.28,8.28,0,0,1,.72-8c3.17-5,9.28-5.83,16.52-3.88a12.84,12.84,0,0,1,9.06,11.66c.35,5.31-14.46,9.23-14.13,12.87Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "384.649px 256.729px"
    },
    id: "el5t2sfq7z2hv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.54,258.85s-2,3.22-1.73,3.55a4.93,4.93,0,0,0,1.62.65Z",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "370.662px 260.95px"
    },
    id: "elb53wo6jzz5f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.67,248.64c-2,1.1-5.48,3.14-6.18,10.67-.72,7.73,1.06,10.36,2.14,11.34.73.66,4.39.81,6.28.17,2.37-.81,7.47-3.5,9.79-7.54,2.73-4.76,3.15-11-.21-13.36A12.28,12.28,0,0,0,377.67,248.64Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "381.601px 259.456px"
    },
    id: "elnek2jg9ch8o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.77,257.73a7.65,7.65,0,0,1-4.91-6.17c-.75-4.91,5.37-7,5.37-7Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "375.513px 251.145px"
    },
    id: "elcgn2qabja4b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.07,249s-1.58,7.08.67,11.46c0,0,1.17-2.77,3.54-2.05s2.27,3.9.44,5.56a3.51,3.51,0,0,1-3.65.88,15.7,15.7,0,0,0,3.53,5.34s7,3.14,13.14-3.74c5.53-6.25,4.5-17.14-4-19.71S377.07,249,377.07,249Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "387.351px 258.446px"
    },
    id: "elnvyh3c0ga0q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.25,276.69h0a9.62,9.62,0,0,1-9.62-9.61V251h0a9.62,9.62,0,0,1,9.62,9.61Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "401.44px 263.845px"
    },
    id: "elsr3ka4ot7pe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.7,248.89a1.66,1.66,0,0,0-1.07,2.09l3.16-1A1.66,1.66,0,0,0,397.7,248.89Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "398.17px 249.896px"
    },
    id: "ellqa2h9tgu1d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352,295.29c-1.37-1.57-1.6-5-3.42-7.41s-1.5-4.78-2.64-3.71-.29,5-.29,5-2.13,3.95-2.31,6,5.16,7.09,5.16,7.09Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "347.668px 293.083px"
    },
    id: "elrjj1v2dngf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.92,288.87s-2.17,3-11.92-.92c-2.69-1.1-.87,4.69,2.43,7.09,3.06,2.22,6.88,2.91,9.94,5C346.38,299.72,345.92,288.87,345.92,288.87Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "339.536px 293.926px"
    },
    id: "elymxbsxgbnpk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.71,278c-2.77,1-5.2,2.08-7.8,6.95-3.33,6.26-9.38,18.52-9.38,18.52L352,295.29s-1.1-1.55-3.14,1.83-1.14,4.31-1.14,4.31,8.78,11.76,10.39,13.25,4.26.34,6-2,10.66-18.53,10.66-18.53S380.64,283.9,376.71,278Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "362.794px 296.674px"
    },
    id: "elta224hnbcws",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.06,277.55a10.6,10.6,0,0,0-8.46,5.63c-3.32,6-6.82,12.77-6.82,12.77s2.41,5.81,8.54,6.25c0-.6,5-9.5,6.91-13.31S379.94,279.26,378.06,277.55Z",
    style: {
      fill: "rgb(234, 57, 93)",
      transformOrigin: "371.175px 289.875px"
    },
    id: "el10em8pc2t2h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.92,337.13l.53-5.62a21.32,21.32,0,0,0,8.48-3.21s-1.81,2.89-6.76,4.21L388.05,338l-.29,10.9Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "391.425px 338.6px"
    },
    id: "eldjngra1a2qq",
    className: "animable"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0000",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourse);
export default __webpack_public_path__ + "static/media/course.bf07c8f8e3e5c58a25507dbbf87ab696.svg";
export { ForwardRef as ReactComponent };